import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  getPagedNotificationsByUserId(userId: string, payload: any) {
    return this.http.post(
      `${environment.apiUrl}/notification/get-paged/${userId}`,
      payload
    );
  }

  markAllNotificationsAsOpened(userId: string) {
    return this.http.put(
      `${environment.apiUrl}/notification/mark-all-as-opened/${userId}`,
      {}
    );
  }
  
  toggleNotificationOpenedStatus(notificationId: string) {
    return this.http.put(
      `${environment.apiUrl}/notification/update/${notificationId}`,
      { isOpened: true }
    );
  }

  /**
   * Permanently dismiss a notification (calls the existing
   * DELETE /notification/delete/:id endpoint). The bell-dropdown's
   * trash icon uses this to clear stale items.
   */
  dismissNotification(notificationId: string) {
    return this.http.delete(
      `${environment.apiUrl}/notification/delete/${notificationId}`
    );
  }
}
